export const visionTemplate = [
    {
        questionDimension: 'Vision',
        type: 'Matrix',
        questionLabel: 'Vision',
        options: [
            {
                label: "Strongly disagree",
                value: "1"
            },
            {
                label: "Somewhat disagree",
                value: "2"
            },
            {
                label: "Neither agree nor disagree",
                value: "3"
            },
            {
                label: "Somewhat agree",
                value: "4"
            },
            {
                label: "Strongly agree",
                value: "5"
            }
        ],
        question: '',
        matrixQuestions: [{
            text: 'My organization has a good long-term future.', value: '', isSelected: true
        },

        {
            text: `I could explain my organization's vision to someone who doesn't work here.`, value: '', isSelected: true

        },
        {
            text: `I am inspired by my organization's vision.`, value: '', isSelected: true

        },
        {
            text: `This organization's vision is realistic and achievable.`, value: '', isSelected: false

        }]
    }
]

